module.exports = __webpack_public_path__ + "static/media/party.97209932.png";